<template>
	<ja-modal v-if="image" :show="!!image">
		<div class="image-preview">
			<header>
				<h1>
					{{ image.name }}
				</h1>
				<ja-close-button
					class="close-button"
					name="close"
					@click.native="closeModal"
				></ja-close-button>
			</header>
			<content>
				<img
					:src="`data:${image.fileType};base64, ${image.fileDataBase64}`"
					:alt="image.name"
				/>
				<div class="body-text-1">
					{{ image.description }}
				</div>
			</content>
			<footer>
				<ja-button class="small" name="download" @click.native="downloadImage">
					{{ $t('download') }}
				</ja-button>
			</footer>
		</div>
	</ja-modal>
</template>
<script>
import '@/components/icons/modal-close';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/ui/Button';
import CloseButton from '@/components/ui/CloseButton';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button,
		jaCloseButton: CloseButton
	},
	props: {
		image: {
			type: Object,
			default: null
		}
	},
	methods: {
		downloadImage() {
			this.$emit('fileRequested', this.image);
			this.closeModal();
		},
		closeModal() {
			this.$emit('closeModal');
		}
	}
};
</script>
<style lang="scss" scoped>
.image-preview {
	width: 100%;

	header {
		padding: 16px;
		text-align: center;
		border-bottom: 1px solid $container-border;
		position: relative;

		.close-button {
			margin: auto;
		}

		h1 {
			margin: 0;
		}
	}
	content {
		width: 100%;
		padding: 32px;
		text-align: left;

		img {
			max-width: 100%;
		}
	}
	footer {
		text-align: center;
		padding: 16px;
		border-top: 1px solid $container-border;
	}
}
</style>
